import { render, staticRenderFns } from "./z_artile.vue?vue&type=template&id=4fff33e7&scoped=true&"
import script from "./z_artile.vue?vue&type=script&lang=js&"
export * from "./z_artile.vue?vue&type=script&lang=js&"
import style0 from "./z_artile.vue?vue&type=style&index=0&id=4fff33e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fff33e7",
  null
  
)

export default component.exports